import nordUk from "../config/nordUk.js";
import { Button } from "../components/UI/button.js";

export default function Error(_) {
  const config = nordUk;

//   useEffect(()=>{
//     function getCookie(name) {
//       const cookies = document.cookie.split(';');
//       for (const cookie of cookies) {
//         const [key, value] = cookie.trim().split('=');
//         if (key === name) return value;
//       }
//       return null;
//     }

//     const registration_id = getCookie("nj_nord_reg_id");
//     const msisdn = getCookie("nj_msisdn");
//     const click_id = getCookie("nj_click_id");
//     console.log(click_id, msisdn, registration_id)

//     callAPI({
//       registration_id: registration_id,
//       msisdn: msisdn,
//       click_id: click_id,

//     }, 'confirmRegistration')
//   }, [])

  const handleClick = () => {
    window.open("https://my.nordaccount.com/", "_self");
  };

  return (
    <>
      <div
        className="nord min-h-screen flex sm:flex-row"
        style={{
          backgroundColor: config.background_color,
          color: config.text_color,
          fontFamily: config.font_family,
        }}
      >
        <div className="md:w-1/2 bg-blue-500  justify-center items-center relative hidden sm:flex w-1/4">
          <img
            src={config.featured_image}
            className="max-w-full h-auto w-[80%]"
            alt="Featured"
          />
        </div>
        <div className="w-full sm:w-3/4 md:w-1/2 flex flex-col justify-between items-start bg-white">
          <div className="w-full flex justify-center items-center">
            <div className="flex items-center justify-between w-full">
              <div className="w-1/3 flex justify-center items-center"></div>
              <div className="w-1/3 flex justify-center items-center">
                {config.logo_url && !config.logo_under_button && (
                  <img
                    src={config.logo_url}
                    alt={"Logo"}
                    id="Logo"
                    className={`${
                      config.logo_size === "Small"
                        ? "w-[300px] lg:w-[200px] md:w-[200px] max-w-none"
                        : ""
                    }`}
                  />
                )}
              </div>
              <div className="w-1/3 flex justify-center items-center"></div>
            </div>
          </div>
          <div className="w-full flex-col justify-center items-center px-4">
            <div className="w-full flex justify-center items-center">
              <h2
                className="text-center font-bold lg:text-3xl md:text-2xl text-xl leading-snug"
                style={{
                  color: config.titles_color || "#000",
                }}
              >
                An error occured when registering for your <br /> NordVPN account
                <br />
                <br /> Please try again
              </h2>
            </div>

            <div className="w-full flex flex-col items-center justify-center mt-10">
              <div className="w-full flex md:flex-row lg:flex-row md:justify-center items-center gap-8 mx-auto max-w-md">
                <Button
                  className={`flex flex-row gap-2 lg:h-[98px]  h-[70px] px-5 py-4 w-full  font-semibold text-lg rounded-full tracking-wider
                    md:!text-xl lg:!text-2xl`}
                  style={{
                    backgroundColor: config.button_primary_color || "#e02f1fe3",
                    color: config.button_text_color || "#000",
                    fontSize: config.button_font_size,
                  }}
                  onClick={handleClick}
                >
                  Access NordVPN
                </Button>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center items-center relative sm:hidden invisible">
            <img
              src={config.featured_image}
              className="max-w-full h-auto w-[50%]"
              alt="Featured"
            />
          </div>

          <div
            className="text-center w-full flex-col items-center justify-center  bg-black
           p-3"
          >
            <div className="flex flex-col items-center ">
              {config.show_footer && (
                <>
                  <div
                    className="flex gap-2 items-center "
                    dangerouslySetInnerHTML={{
                      __html: config.footer_content || "",
                    }}
                  ></div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
